import { bindingSummaryLine, operationLabel, BINDING_OPERATIONS } from "@/lib/screenBindings";

/** Iter 45 — counts strip for the bindings page. Honest empty state. */
export default function BindingSummaryStrip({ summary, onFilter }) {
  if (!summary) return null;
  if (!summary.bindings) {
    return (
      <div className="ml-card px-4 py-3 text-xs text-[var(--ml-text-secondary)]" data-testid="sb-summary" data-total="0">
        No observed screen format bindings yet — parse the RPG programs (EXFMT / WRITE / READ / READC statements) and the display-file DDS they use, then rebuild.
      </div>
    );
  }
  const cell = (label, value, testid, filter, tone) => (
    <button
      type="button"
      onClick={() => onFilter?.(filter)}
      className="ml-card px-4 py-3 text-left hover:border-[var(--ml-primary)] transition-colors"
      data-testid={testid}
      data-value={value}
    >
      <div className="ml-mono text-[10px] uppercase tracking-widest text-[var(--ml-text-secondary)]">{label}</div>
      <div className="text-2xl font-semibold tabular-nums mt-1" style={tone ? { color: tone } : undefined}>{value}</div>
    </button>
  );
  return (
    <div className="space-y-3" data-testid="sb-summary" data-total={summary.bindings}>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
        {cell("Active bindings", summary.bindings, "sb-summary-total", { status: "", origin: "" })}
        {cell("Parser-proven", summary.parser ?? summary.bindings, "sb-summary-parser", { origin: "parser" }, "#0e6027")}
        {cell("Manual · consultant", summary.manual ?? 0, "sb-summary-manual", { origin: "manual" }, "#a2191f")}
        {cell("Bound", `${summary.bound}`, "sb-summary-bound", { status: "bound" }, "#0e6027")}
        {cell("Ambiguous format names", summary.ambiguous, "sb-summary-ambiguous", { status: "ambiguous" }, "#8a6d00")}
        {cell("Unresolved format usages", summary.unresolved, "sb-summary-unresolved", { status: "unresolved" })}
      </div>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-[var(--ml-text-secondary)]" data-testid="sb-summary-line">
        <span>{bindingSummaryLine(summary)} · {summary.programs} program{summary.programs === 1 ? "" : "s"} · {summary.display_files} display file{summary.display_files === 1 ? "" : "s"}</span>
        <span className="ml-mono text-[10px] uppercase tracking-widest">
          {BINDING_OPERATIONS.filter((o) => summary.by_operation?.[o]).map((o) => (
            <button key={o} type="button" onClick={() => onFilter?.({ operation: o })} className="mr-2 hover:underline" data-testid={`sb-summary-op-${o}`}>
              {operationLabel(o)} {summary.by_operation[o]}
            </button>
          ))}
        </span>
        <span>Only deterministic bindings are shown as parser-proven — a program statement that displays or reads the format, matched to the parsed DSPF that defines it. Manual bindings are consultant decisions, not parser-proven{summary.manual_inactive ? ` (${summary.manual_inactive} deactivated)` : ""}. Not a complete screen-flow analysis.</span>
      </div>
    </div>
  );
}
